import React, { Component, PropTypes } from 'react';
import { Units, Colors, hexToRgba } from 'Css';
import classNames from 'classnames';

const css = oxygenCss({
  root: {
    margin: Units.base,
    borderRadius: 2,
    backgroundColor: Colors.theme.Light.card,
    boxShadow: '0 1px 6px rgba(0, 0, 0, 0.12), 0 1px 4px rgba(0, 0, 0, 0.24)'
  },
  title: {
    backgroundColor: Colors.material.grey[200].hex,
    color: Colors.material.grey[200].text.default,
    padding: Units.base / 2,
    borderStyle: 'none none solid none',
    borderColor: Colors.text.Light.divider,
    borderWidth: 1
  },
  list: {
    '&constrained': {
      height: 400,
      overflow: 'auto',
      '&mini': {
        height: 120
      }
    }
  },
  bottomBar: {
    backgroundColor: Colors.material.grey[100].hex,
    color: Colors.material.grey[100].text.default,
    padding: Units.base,
    fontSize: 12,
    lineHeight: '20px',
    borderStyle: 'solid none none none',
    borderColor: Colors.text.Light.divider,
    borderWidth: 1
  },
  listItem: {
    fontSize: 16,
    lineHeight: '24px',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    padding: Units.base,
    cursor: 'pointer',
    ':hover': {
      backgroundColor: `${hexToRgba(
        Colors.material.coursio[500].hex,
        25
      )} !important`
    },
    '&selected': {
      backgroundColor: `${hexToRgba(Colors.material.coursio[300].hex, 40)}`,
      color: Colors.material.coursio[300].text.default
    }
  }
});

class CardList extends Component {
  static propTypes = {
    children: PropTypes.node,
    header: PropTypes.node,
    footer: PropTypes.node,
    mini: PropTypes.bool,
    constrained: PropTypes.bool
  };

  render() {
    const { children, header, footer, mini, constrained } = this.props;
    const listClasses = classNames(css.list, {
      [css.mini]: mini,
      [css.constrained]: constrained
    });
    return (
      <div className={css.root}>
        {header && <div className={css.title}>{header}</div>}
        <div className={listClasses}>{children}</div>
        {footer && <div className={css.bottomBar}>{footer}</div>}
      </div>
    );
  }
}

export default CardList;



// WEBPACK FOOTER //
// ./src/js/components/CardList.js